// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file protobuf/journey/data/categories/marketplace_property_category.proto (package od_protos.journey.data.categories, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BoolValueJson, DoubleValueJson, Int32ValueJson, Int64ValueJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_protobuf_journey_data_options_options } from "../options/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/categories/marketplace_property_category.proto.
 */
export const file_protobuf_journey_data_categories_marketplace_property_category: GenFile = /*@__PURE__*/
  fileDesc("CkRwcm90b2J1Zi9qb3VybmV5L2RhdGEvY2F0ZWdvcmllcy9tYXJrZXRwbGFjZV9wcm9wZXJ0eV9jYXRlZ29yeS5wcm90bxIhb2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzIsOPAQobTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Em4KEGRldGFpbF9wYWdlX3ZpZXcYASABKAsyUi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkRldGFpbFBhZ2VWaWV3RXZlbnRIABJ0ChNzaW1pbGFyX2hvbWVzX2NsaWNrGAIgASgLMlUub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5TaW1pbGFySG9tZXNDbGlja0V2ZW50SAAScgoSdG91cl9ib29raW5nX3N0YXJ0GAMgASgLMlQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyQm9va2luZ1N0YXJ0RXZlbnRIABJgCghyZWFjdGlvbhgEIAEoCzJMLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuUmVhY3Rpb25FdmVudEgAEmUKC29mZmVyX3N0YXJ0GAUgASgLMk4ub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5PZmZlclN0YXJ0RXZlbnRIABJaCgVzaGFyZRgGIAEoCzJJLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuU2hhcmVFdmVudEgAEnsKF3JlbnRhbF9zY2FtX2Jhbm5lcl92aWV3GAcgASgLMlgub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5SZW50YWxTY2FtQmFubmVyVmlld0V2ZW50SAAShgEKHXJlbnRhbF9zY2FtX2Jhbm5lcl9sZWFybl9tb3JlGAggASgLMl0ub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5SZW50YWxTY2FtQmFubmVyTGVhcm5Nb3JlRXZlbnRIABJ8ChduYXR1cmFsX2xhbmd1YWdlX3NlYXJjaBgJIAEoCzJZLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTmF0dXJhbExhbmd1YWdlU2VhcmNoRXZlbnRIABJwChF0b3VyX2Zsb3dfc3RhcnRlZBgKIAEoCzJTLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckZsb3dTdGFydGVkRXZlbnRIABJyChJ0b3VyX3Nsb3Rfc2VsZWN0ZWQYCyABKAsyVC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJTbG90U2VsZWN0ZWRFdmVudEgAEoABChl0b3VyX3ZlcmlmaWNhdGlvbl9zdGFydGVkGAwgASgLMlsub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyVmVyaWZpY2F0aW9uU3RhcnRlZEV2ZW50SAAShAEKG3RvdXJfdmVyaWZpY2F0aW9uX2NvbXBsZXRlZBgNIAEoCzJdLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91clZlcmlmaWNhdGlvbkNvbXBsZXRlZEV2ZW50SAASegoWdG91cl9ib29raW5nX2F0dGVtcHRlZBgOIAEoCzJYLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckJvb2tpbmdBdHRlbXB0ZWRFdmVudEgAEnoKFnRvdXJfYm9va2luZ19jb21wbGV0ZWQYDyABKAsyWC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJCb29raW5nQ29tcGxldGVkRXZlbnRIABJ0ChN0b3VyX2Zsb3dfYWJhbmRvbmVkGBAgASgLMlUub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyRmxvd0FiYW5kb25lZEV2ZW50SAAScgoSaWR2X3Nlc3Npb25fZGVuaWVkGBEgASgLMlQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5JZHZTZXNzaW9uRGVuaWVkRXZlbnRIABJ4ChV0b3VyX2NhbmNlbF9jb25maXJtZWQYEiABKAsyVy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJDYW5jZWxDb25maXJtZWRFdmVudEgAEngKFXRvdXJfY2FuY2VsX3N1Y2NlZWRlZBgTIAEoCzJXLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckNhbmNlbFN1Y2NlZWRlZEV2ZW50SAASfAoXdG91cl9mZWVkYmFja19zdWJtaXR0ZWQYFCABKAsyWS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJGZWVkYmFja1N1Ym1pdHRlZEV2ZW50SAAScgoSYWNjZXNzX2NvZGVfbG9hZGVkGBUgASgLMlQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5BY2Nlc3NDb2RlTG9hZGVkRXZlbnRIABJ6ChZzZWFyY2hfcmVzdWx0X3NlbGVjdGVkGBYgASgLMlgub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5TZWFyY2hSZXN1bHRTZWxlY3RlZEV2ZW50SAAScAoRbWFwX2dsb2JlX2VudGVyZWQYFyABKAsyUy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lk1hcEdsb2JlRW50ZXJlZEV2ZW50SAASbgoQbWFwX2dsb2JlX2V4aXRlZBgYIAEoCzJSLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTWFwR2xvYmVFeGl0ZWRFdmVudEgAEnUKE2Nhcm91c2VsX2VuZ2FnZW1lbnQYGSABKAsyVi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkNhcm91c2VsRW5nYWdlbWVudEV2ZW50SAASbQoPcHJvcGVydHlfc2VhcmNoGBogASgLMlIub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Qcm9wZXJ0eVNlYXJjaEV2ZW50SAASZwoMYWRkX2Zhdm9yaXRlGBsgASgLMk8ub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5BZGRGYXZvcml0ZUV2ZW50SAASbQoPb2ZmZXJfc3VibWl0dGVkGBwgASgLMlIub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5PZmZlclN1Ym1pdHRlZEV2ZW50SAASbQoPYWNjb3VudF9jcmVhdGVkGB0gASgLMlIub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5BY2NvdW50Q3JlYXRlZEV2ZW50SAASawoOdG91cl9zY2hlZHVsZWQYHiABKAsyUS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJTY2hlZHVsZWRFdmVudEgAEmsKDnRvdXJfY29tcGxldGVkGB8gASgLMlEub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyQ29tcGxldGVkRXZlbnRIABJ2ChRjZXJ0YWludHlfcGFuZWxfdmlldxggIAEoCzJWLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuQ2VydGFpbnR5UGFuZWxWaWV3RXZlbnRIABJ4ChVjZXJ0YWludHlfcGFuZWxfY2xpY2sYISABKAsyVy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkNlcnRhaW50eVBhbmVsQ2xpY2tFdmVudEgAEn4KGGxpc3RpbmdfbWVkaWFfaW1wcmVzc2lvbhgiIAEoCzJaLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTGlzdGluZ01lZGlhSW1wcmVzc2lvbkV2ZW50SAASdgoUbGlzdGluZ19tZWRpYV90b2dnbGUYIyABKAsyVi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lkxpc3RpbmdNZWRpYVRvZ2dsZUV2ZW50SAASegoWbGlzdGluZ192aWRlb19wbGF5YmFjaxgkIAEoCzJYLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTGlzdGluZ1ZpZGVvUGxheWJhY2tFdmVudEgAEnQKE29mZmVyX2NoZWNrb3V0X3N0ZXAYJSABKAsyVS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lk9mZmVyQ2hlY2tvdXRTdGVwRXZlbnRIABJpCg10b3VyX2NhbmNlbGVkGCYgASgLMlAub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyQ2FuY2VsZWRFdmVudEgAEm8KEHRvdXJfcmVzY2hlZHVsZWQYJyABKAsyUy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJSZXNjaGVkdWxlZEV2ZW50SAASiQEKHmN1c3RvbWVyX3Byb3BlcnR5X3NhdmVfY2hhbmdlZBgoIAEoCzJfLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuQ3VzdG9tZXJQcm9wZXJ0eVNhdmVDaGFuZ2VkRXZlbnRIABJ4ChVnZXRfcHJlYXBwcm92ZWRfY2xpY2sYKSABKAsyVy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkdldFByZWFwcHJvdmVkQ2xpY2tFdmVudEgAEnAKEWRyb3Bfc3RhdGVfdmlld2VkGCogASgLMlMub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ecm9wU3RhdGVWaWV3ZWRFdmVudEgAEnAKEWRyb3Bfb2ZmZXJfdmlld2VkGCsgASgLMlMub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ecm9wT2ZmZXJWaWV3ZWRFdmVudEgAEncKFXRvdXJfZmxvd19zdGVwX3ZpZXdlZBgsIAEoCzJWLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckZsb3dTdGVwVmlld2VkRXZlbnRIABJuChB0b3VyX2Zsb3dfZmFpbGVkGC0gASgLMlIub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyRmxvd0ZhaWxlZEV2ZW50SAASfgoYZHJvcF9wcmVhcHByb3ZhbF9oYW5kb2ZmGC4gASgLMloub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ecm9wUHJlYXBwcm92YWxIYW5kb2ZmRXZlbnRIABJ6ChZsaXN0aW5nX29mZmVyX3JlY2VpdmVkGC8gASgLMlgub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5MaXN0aW5nT2ZmZXJSZWNlaXZlZEV2ZW50SAAaMQoTRGV0YWlsUGFnZVZpZXdFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAk6BPjYGAEaUgoWU2ltaWxhckhvbWVzQ2xpY2tFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSHAoUY2xpY2tlZF9hZGRyZXNzX3V1aWQYAiABKAk6BPjYGAEakgEKFVRvdXJCb29raW5nU3RhcnRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSEQoJcGxhY2VtZW50GAIgASgJEjAKC3ByaWNlX2NlbnRzGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDY0VmFsdWUSGAoGc291cmNlGAQgASgJQgja2BgECgIoAToE+NgYARqjAQoNUmVhY3Rpb25FdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSDgoGc291cmNlGAIgASgJEmYKCHJlYWN0aW9uGAMgASgOMlQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5SZWFjdGlvbkV2ZW50UmVhY3Rpb246BPjYGAEaPQoPT2ZmZXJTdGFydEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRIOCgZzb3VyY2UYAiABKAk6BPjYGAEaOAoKU2hhcmVFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSDgoGc291cmNlGAIgASgJOgT42BgBGjcKGVJlbnRhbFNjYW1CYW5uZXJWaWV3RXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJOgT42BgBGjwKHlJlbnRhbFNjYW1CYW5uZXJMZWFybk1vcmVFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAk6BPjYGAEalwQKGk5hdHVyYWxMYW5ndWFnZVNlYXJjaEV2ZW50Eg0KBXF1ZXJ5GAEgASgJEnIKB3N1cmZhY2UYAiABKA4yYS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lk5hdHVyYWxMYW5ndWFnZVNlYXJjaEV2ZW50LlN1cmZhY2USJQoTZ3JhcGhxbF9jbGllbnRfbmFtZRgDIAEoCUII2tgYBAoCKAESGAoGbWFya2V0GAQgASgJQgja2BgECgIoARIPCgdib3VuZGVkGAUgASgIEioKBWxpbWl0GAYgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSNgoRY2x1c3Rlcl9wcmVjaXNpb24YByABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIWCg5ob21lc19yZXR1cm5lZBgIIAEoBRIeCgxlbXB0eV9yZWFzb24YCSABKAlCCNrYGAQKAigBEhkKEXJlc3VsdHNfdHJ1bmNhdGVkGAogASgIEhkKEWVuZ2luZV9sYXRlbmN5X21zGAsgASgDIlIKB1N1cmZhY2USFwoTU1VSRkFDRV9VTlNQRUNJRklFRBAAEg4KClNUQU5EQUxPTkUQARIQCgxNQVBfQ0xVU1RFUlMQAhIMCghNQVBfUElOUxADGukBChRUb3VyRmxvd1N0YXJ0ZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSFAoMY2FuX3RvdXJfbm93GAIgASgIEhMKC2lzX3ZlcmlmaWVkGAMgASgIEhkKB2Zsb3dfaWQYBCABKAlCCNrYGAQKAigBEjcKE2F2YWlsYWJpbGl0eV9sb2FkZWQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuQm9vbFZhbHVlEjYKEmVsaWdpYmlsaXR5X2xvYWRlZBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWU6BPjYGAEaxgIKFVRvdXJTbG90U2VsZWN0ZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSEQoJc2xvdF90aW1lGAIgASgJEhMKC2lzX3RvdXJfbm93GAMgASgIEnwKCnRpbWVfZ3JvdXAYBCABKA4yXi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJTbG90U2VsZWN0ZWRFdmVudC5UaW1lR3JvdXBCCOLYGAQqAggBEhkKB2Zsb3dfaWQYBSABKAlCCNrYGAQKAigBIlAKCVRpbWVHcm91cBIaChZUSU1FX0dST1VQX1VOU1BFQ0lGSUVEEAASCwoHTU9STklORxABEg0KCUFGVEVSTk9PThACEgsKB0VWRU5JTkcQAzoE+NgYARqjAQocVG91clZlcmlmaWNhdGlvblN0YXJ0ZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSZwoEc3RlcBgCIAEoDjJPLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVmVyaWZpY2F0aW9uU3RlcEII4tgYBCoCCAE6BPjYGAEa1wEKHlRvdXJWZXJpZmljYXRpb25Db21wbGV0ZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSZwoEc3RlcBgCIAEoDjJPLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVmVyaWZpY2F0aW9uU3RlcEII4tgYBCoCCAESMAoLZHVyYXRpb25fbXMYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZToE+NgYARplChlUb3VyQm9va2luZ0F0dGVtcHRlZEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRIRCglzbG90X3RpbWUYAiABKAkSGQoHZmxvd19pZBgDIAEoCUII2tgYBAoCKAE6BPjYGAEaywEKGVRvdXJCb29raW5nQ29tcGxldGVkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEhIKCmJvb2tpbmdfaWQYAiABKAkSEQoJc2xvdF90aW1lGAMgASgJEjsKFnRvdGFsX2Zsb3dfZHVyYXRpb25fbXMYBCABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRITCgtzdGVwc19jb3VudBgFIAEoBRIZCgdmbG93X2lkGAYgASgJQgja2BgECgIoAToE+NgYARqcBAoWVG91ckZsb3dBYmFuZG9uZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSewoJbGFzdF9zdGVwGAIgASgOMl4ub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyRmxvd0FiYW5kb25lZEV2ZW50LkZsb3dTdGVwQgji2BgEKgIIARIZChFoYWRfc2xvdF9zZWxlY3RlZBgDIAEoCBIZCgdmbG93X2lkGAQgASgJQgja2BgECgIoARIXCg9ib29raW5nX3BlbmRpbmcYBSABKAgimQIKCEZsb3dTdGVwEhkKFUZMT1dfU1RFUF9VTlNQRUNJRklFRBAAEhIKDlRJTUVfU0VMRUNUSU9OEAESCQoFTE9HSU4QAhIWChJQSE9ORV9WRVJJRklDQVRJT04QAxITCg9JRF9WRVJJRklDQVRJT04QBBIKCgZSRVZJRVcQBRIQCgxDT05GSVJNQVRJT04QBhIbChdQSE9ORV9OVU1CRVJfQ09MTEVDVElPThAHEhMKD0NPTlRBQ1RfU1VQUE9SVBAIEhgKFEFWQUlMQUJJTElUWV9MT0FESU5HEAkSFgoSQVZBSUxBQklMSVRZX0VSUk9SEAoSFwoTRUxJR0lCSUxJVFlfTE9BRElORxALEgsKB0JPT0tJTkcQDDoE+NgYARq+AQoXVG91ckZsb3dTdGVwVmlld2VkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEg8KB2Zsb3dfaWQYAiABKAkSdgoEc3RlcBgDIAEoDjJeLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckZsb3dBYmFuZG9uZWRFdmVudC5GbG93U3RlcEII4tgYBCoCCAE6BPjYGAEa0wUKE1RvdXJGbG93RmFpbGVkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEg8KB2Zsb3dfaWQYAiABKAkSdgoEc3RlcBgDIAEoDjJeLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckZsb3dBYmFuZG9uZWRFdmVudC5GbG93U3RlcEII4tgYBCoCCAESegoGcmVhc29uGAQgASgOMmAub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyRmxvd0ZhaWxlZEV2ZW50LkZhaWx1cmVSZWFzb25CCOLYGAQqAggBEh8KF2Jvb2tpbmdfb3V0Y29tZV91bmtub3duGAUgASgIIvkCCg1GYWlsdXJlUmVhc29uEh4KGkZBSUxVUkVfUkVBU09OX1VOU1BFQ0lGSUVEEAASHwobQVZBSUxBQklMSVRZX1JFUVVFU1RfRkFJTEVEEAESFgoSTk9fQVZBSUxBQkxFX1NMT1RTEAISHgoaRUxJR0lCSUxJVFlfUkVRVUVTVF9GQUlMRUQQAxIcChhDT05UQUNUX1NVUFBPUlRfUkVRVUlSRUQQBBIVChFQSE9ORV9TQVZFX0ZBSUxFRBAFEhQKEFNMT1RfVU5BVkFJTEFCTEUQBhIQCgxVTkFVVEhPUklaRUQQBxITCg9VTkFVVEhFTlRJQ0FURUQQCBIdChlSRUFVVEhFTlRJQ0FUSU9OX1JFUVVJUkVEEAkSEQoNSU5WQUxJRF9JTlBVVBAKEhMKD0JPT0tJTkdfVElNRU9VVBALEhMKD0JPT0tJTkdfVU5LTk9XThAMEiEKHUFWQUlMQUJJTElUWV9USU1FWk9ORV9NSVNTSU5HEA06BPjYGAEazQIKFUlkdlNlc3Npb25EZW5pZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSggEKDWRlbmlhbF9yZWFzb24YAiABKA4yYS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LklkdlNlc3Npb25EZW5pZWRFdmVudC5EZW5pYWxSZWFzb25CCOLYGAQqAggBIpIBCgxEZW5pYWxSZWFzb24SHQoZREVOSUFMX1JFQVNPTl9VTlNQRUNJRklFRBAAEhQKEEFMUkVBRFlfVkVSSUZJRUQQARIbChdSRVRSWV9USFJFU0hPTERfUkVBQ0hFRBACEhQKEEZFQVRVUkVfRElTQUJMRUQQAxINCglUSU1FRF9PVVQQBBILCgdVTktOT1dOEAU6BPjYGAEaRwoYVG91ckNhbmNlbENvbmZpcm1lZEV2ZW50Eg8KB3RvdXJfaWQYASABKAkSFAoMYWRkcmVzc191dWlkGAIgASgJOgT42BgBGkcKGFRvdXJDYW5jZWxTdWNjZWVkZWRFdmVudBIPCgd0b3VyX2lkGAEgASgJEhQKDGFkZHJlc3NfdXVpZBgCIAEoCToE+NgYARqFBAoaVG91ckZlZWRiYWNrU3VibWl0dGVkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEoABCglzZW50aW1lbnQYAiABKA4yYy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlRvdXJGZWVkYmFja1N1Ym1pdHRlZEV2ZW50LlNlbnRpbWVudEII4tgYBCoCCAESggEKBnNvdXJjZRgDIAEoDjJoLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckZlZWRiYWNrU3VibWl0dGVkRXZlbnQuRmVlZGJhY2tTb3VyY2VCCOLYGAQqAggBEhkKB3RvdXJfaWQYBCABKAlCCNrYGAQKAigBIlwKCVNlbnRpbWVudBIZChVTRU5USU1FTlRfVU5TUEVDSUZJRUQQABIMCghQT1NJVElWRRABEgsKB05FVVRSQUwQAhIMCghORUdBVElWRRADEgsKB1VOS05PV04QBCJKCg5GZWVkYmFja1NvdXJjZRIfChtGRUVEQkFDS19TT1VSQ0VfVU5TUEVDSUZJRUQQABIJCgVRVUlDSxABEgwKCERFVEFJTEVEEAI6BPjYGAEa5wIKFUFjY2Vzc0NvZGVMb2FkZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSDwoHdG91cl9pZBgCIAEoCRKPAQoUc2VjdXJpdHlfc3lzdGVtX3R5cGUYAyABKA4yZy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkFjY2Vzc0NvZGVMb2FkZWRFdmVudC5TZWN1cml0eVN5c3RlbVR5cGVCCOLYGAQqAggBIo4BChJTZWN1cml0eVN5c3RlbVR5cGUSJAogU0VDVVJJVFlfU1lTVEVNX1RZUEVfVU5TUEVDSUZJRUQQABINCglTTUFSVFJFTlQQARIICgRBUkNPEAISDgoKQ0xFTUVOVElORRADEggKBEtOT1gQBBIICgRMSU5LEAUSCAoETk9ORRAGEgsKB1VOS05PV04QBzoE+NgYARqRAgoZU2VhcmNoUmVzdWx0U2VsZWN0ZWRFdmVudBKCAQoLcmVzdWx0X3R5cGUYASABKA4yYy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LlNlYXJjaFJlc3VsdFNlbGVjdGVkRXZlbnQuUmVzdWx0VHlwZUII4tgYBCoCCAESFAoMcXVlcnlfbGVuZ3RoGAIgASgFEhcKD3Jlc3VsdF9wb3NpdGlvbhgDIAEoBSJACgpSZXN1bHRUeXBlEhsKF1JFU1VMVF9UWVBFX1VOU1BFQ0lGSUVEEAASCAoEWk9ORRABEgsKB0xJU1RJTkcQAhoWChRNYXBHbG9iZUVudGVyZWRFdmVudBpeChNNYXBHbG9iZUV4aXRlZEV2ZW50EhMKC2R1cmF0aW9uX21zGAEgASgFEhYKDnJlZ2lvbl9jaGFuZ2VkGAIgASgIEhoKEnRyYXZlbF9kaXN0YW5jZV9rbRgDIAEoBRrkAQoXQ2Fyb3VzZWxFbmdhZ2VtZW50RXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEhMKC3Bob3RvX2NvdW50GAIgASgFEhUKDXBob3Rvc192aWV3ZWQYAyABKAUSEwoLc3dpcGVfY291bnQYBCABKAUSGwoTc2NydWJfc2Vzc2lvbl9jb3VudBgFIAEoBRIZChFzY3J1Yl9waG90b19jb3VudBgGIAEoBRIXCg9tYXhfcGhvdG9faW5kZXgYByABKAUSGwoTbGFuZGluZ19waG90b19pbmRleBgIIAEoBToE+NgYARrZBAoTUHJvcGVydHlTZWFyY2hFdmVudBJ1Cgd0cmlnZ2VyGAEgASgOMloub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Qcm9wZXJ0eVNlYXJjaEV2ZW50LlRyaWdnZXJCCOLYGAQqAggBEhgKBm1hcmtldBgCIAEoCUII2tgYBAoCKAESFQoNcmVzdWx0c19jb3VudBgDIAEoBRItCghtaW5fYmVkcxgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi4KCW1pbl9iYXRocxgFIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjQKD21pbl9wcmljZV9jZW50cxgGIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEjQKD21heF9wcmljZV9jZW50cxgHIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEhYKBHNvcnQYCCABKAlCCNrYGAQKAigBEgwKBHBhZ2UYCSABKAUiqAEKB1RyaWdnZXISFwoTVFJJR0dFUl9VTlNQRUNJRklFRBAAEhAKDEZJTFRFUl9BUFBMWRABEhAKDFFVSUNLX0ZJTFRFUhACEgwKCE1BUF9NT1ZFEAMSEwoPTE9DQVRJT05fU0VMRUNUEAQSEAoMU0FWRURfU0VBUkNIEAUSCQoFUkVTRVQQBhIPCgtTT1JUX0NIQU5HRRAHEg8KC1BBR0VfQ0hBTkdFEAgacAoQQWRkRmF2b3JpdGVFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSDgoGc291cmNlGAIgASgJEjAKC3ByaWNlX2NlbnRzGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDY0VmFsdWU6BPjYGAEa1wIKE09mZmVyU3VibWl0dGVkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEhoKEmxpc3Rpbmdfb2ZmZXJfdXVpZBgCIAEoCRIwCgtwcmljZV9jZW50cxgDIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEiAKDmZpbmFuY2luZ190eXBlGAQgASgJQgja2BgECgIoARJ1CgdzdXJmYWNlGAUgASgOMloub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5PZmZlclN1Ym1pdHRlZEV2ZW50LlN1cmZhY2VCCOLYGAQqAggBIj0KB1N1cmZhY2USFwoTU1VSRkFDRV9VTlNQRUNJRklFRBAAEhkKFUFHRU5UX09GRkVSX1BPUlRBTF9WMhABOgT42BgBGvABChlMaXN0aW5nT2ZmZXJSZWNlaXZlZEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRIaChJsaXN0aW5nX29mZmVyX3V1aWQYAiABKAkSMAoLcHJpY2VfY2VudHMYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50NjRWYWx1ZRIgCg5maW5hbmNpbmdfdHlwZRgEIAEoCUII2tgYBAoCKAESGAoGc291cmNlGAUgASgJQgja2BgECgIoARIZCgdjaGFubmVsGAYgASgJQgja2BgECgIoARISCgppc19jb3VudGVyGAcgASgIOgT42BgBGsADChZPZmZlckNoZWNrb3V0U3RlcEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRJyCgRzdGVwGAIgASgOMloub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5PZmZlckNoZWNrb3V0U3RlcEV2ZW50LlN0ZXBCCOLYGAQqAggBEjAKC3ByaWNlX2NlbnRzGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDY0VmFsdWUSIAoOZmluYW5jaW5nX3R5cGUYBCABKAlCCNrYGAQKAigBIsEBCgRTdGVwEhQKEFNURVBfVU5TUEVDSUZJRUQQABITCg9DT05UQUNUX0RFVEFJTFMQARITCg9DT05USU5HRU5UX1NBTEUQAhISCg5GVU5ESU5HX1NPVVJDRRADEhoKFlNDSEVEVUxFX0FORF9MT0dJU1RJQ1MQBBIbChdSRVZJRVdfQ09OVFJBQ1RfREVUQUlMUxAFEhgKFEJBQ0tVUF9PRkZFUl9ERVRBSUxTEAYSEgoOT0ZGRVJfREVBRExJTkUQBzoE+NgYARrEAgoTQWNjb3VudENyZWF0ZWRFdmVudBIeCgxhZGRyZXNzX3V1aWQYASABKAlCCNrYGAQKAigBEnwKC2F1dGhfbWV0aG9kGAIgASgOMl0ub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5BY2NvdW50Q3JlYXRlZEV2ZW50LkF1dGhNZXRob2RCCOLYGAQqAggBIogBCgpBdXRoTWV0aG9kEhsKF0FVVEhfTUVUSE9EX1VOU1BFQ0lGSUVEEAASEgoORU1BSUxfUEFTU1dPUkQQARIICgRMSVRFEAISCgoGR09PR0xFEAMSDAoIRkFDRUJPT0sQBBIaChZTRVNTSU9OX0FMUkVBRFlfRVhJU1RTEAUSCQoFQVBQTEUQBjoE+NgYARqyAgoSVG91clNjaGVkdWxlZEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRIPCgd0b3VyX2lkGAIgASgJEhwKCmxpc3RpbmdfaWQYAyABKAlCCNrYGAQKAigBEjEKDXNjaGVkdWxlZF9mb3IYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhAKCGlzX2FnZW50GAUgASgIEm4KDmJvb2tpbmdfc291cmNlGAYgASgOMkwub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Cb29raW5nU291cmNlQgji2BgEKgIIARIcCgpib29raW5nX2lkGAcgASgJQgja2BgECgIoAToE+NgYARrqAwoSVG91ckNvbXBsZXRlZEV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRIPCgd0b3VyX2lkGAIgASgJEhwKCmxpc3RpbmdfaWQYAyABKAlCCNrYGAQKAigBEjEKDXNjaGVkdWxlZF9mb3IYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhAKCGlzX2FnZW50GAUgASgIEocBChFjb21wbGV0aW9uX3NpZ25hbBgGIAEoDjJiLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuVG91ckNvbXBsZXRlZEV2ZW50LkNvbXBsZXRpb25TaWduYWxCCOLYGAQqAggBEm4KDmJvb2tpbmdfc291cmNlGAcgASgOMkwub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Cb29raW5nU291cmNlQgji2BgEKgIIASJKChBDb21wbGV0aW9uU2lnbmFsEiEKHUNPTVBMRVRJT05fU0lHTkFMX1VOU1BFQ0lGSUVEEAASEwoPQVNTVU1FRF9FTEFQU0VEEAE6BPjYGAEaRgoXQ2VydGFpbnR5UGFuZWxWaWV3RXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEg8KB3ZhcmlhbnQYAiABKAk6BPjYGAEaqwIKGENlcnRhaW50eVBhbmVsQ2xpY2tFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkScgoDcm93GAIgASgOMlsub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5DZXJ0YWludHlQYW5lbENsaWNrRXZlbnQuUm93Qgji2BgEKgIIARIYCgZ0YXJnZXQYAyABKAlCCNrYGAQKAigBImUKA1JvdxITCg9ST1dfVU5TUEVDSUZJRUQQABINCglQUklDRV9DVVQQARIQCgxNT05USExZX0NPU1QQAhILCgdLRVlTX0JZEAMSDQoJR1VBUkFOVEVFEAQSDAoIQUNUSVZJVFkQBToE+NgYARrnAQobTGlzdGluZ01lZGlhSW1wcmVzc2lvbkV2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRJvCgttZWRpYV9zdGF0ZRgCIAEoDjJQLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTGlzdGluZ01lZGlhU3RhdGVCCOLYGAQqAggBEiAKDmV4cGVyaW1lbnRfa2V5GAMgASgJQgja2BgECgIoARIZCgd2YXJpYW50GAQgASgJQgja2BgECgIoAToE+NgYARqTAgoXTGlzdGluZ01lZGlhVG9nZ2xlRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEm4KCmZyb21fc3RhdGUYAiABKA4yUC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lkxpc3RpbmdNZWRpYVN0YXRlQgji2BgEKgIIARJsCgh0b19zdGF0ZRgDIAEoDjJQLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuTGlzdGluZ01lZGlhU3RhdGVCCOLYGAQqAggBOgT42BgBGp8DChlMaXN0aW5nVmlkZW9QbGF5YmFja0V2ZW50EhQKDGFkZHJlc3NfdXVpZBgBIAEoCRJ/CgltaWxlc3RvbmUYAiABKA4yYi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5Lkxpc3RpbmdWaWRlb1BsYXliYWNrRXZlbnQuTWlsZXN0b25lQgji2BgEKgIIARI1ChBwb3NpdGlvbl9zZWNvbmRzGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSNQoQZHVyYXRpb25fc2Vjb25kcxgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlIncKCU1pbGVzdG9uZRIZChVNSUxFU1RPTkVfVU5TUEVDSUZJRUQQABIOCgpQTEFZX1NUQVJUEAESDwoLUVVBUlRJTEVfMjUQAhIPCgtRVUFSVElMRV81MBADEg8KC1FVQVJUSUxFXzc1EAQSDAoIQ09NUExFVEUQBToE+NgYARpmCiBDdXN0b21lclByb3BlcnR5U2F2ZUNoYW5nZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSLAoIaXNfc2F2ZWQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuQm9vbFZhbHVlGjYKGEdldFByZWFwcHJvdmVkQ2xpY2tFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAk6BPjYGAEapQIKFERyb3BTdGF0ZVZpZXdlZEV2ZW50Ej4KBXN0YXRlGAEgASgJQi/a2BgrCikaJ29mZmVycyxjb3VudGRvd24sbm9fbWF0Y2hlcyx1bmF2YWlsYWJsZRIzCg5lbGlnaWJsZV9ob21lcxgCIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjIKDXJlc3VsdHNfY291bnQYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIuCgpyZWxlYXNlX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI0ChBvZmZlcl9leHBpcmVzX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBqfAwoURHJvcE9mZmVyVmlld2VkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEhwKCnByaWNpbmdfaWQYAiABKAlCCNrYGAQKAigBEiUKB3Byb2R1Y3QYAyABKAlCFNrYGBAKDhoMYXJtXzYwLGZpeGVkEigKCXBsYWNlbWVudBgEIAEoCUIV2tgYEQoPGg1saXN0LG1hcF9saXN0EhAKCHBvc2l0aW9uGAUgASgFEjAKC3ByaWNlX2NlbnRzGAYgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDY0VmFsdWUSMgoMcmF0ZV9wZXJjZW50GAcgASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEkEKHHByaW5jaXBhbF9hbmRfaW50ZXJlc3RfY2VudHMYCCABKAsyGy5nb29nbGUucHJvdG9idWYuSW50NjRWYWx1ZRIRCglpbmNlbnRpdmUYCSABKAgSNAoQb2ZmZXJfZXhwaXJlc19hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAa8gEKG0Ryb3BQcmVhcHByb3ZhbEhhbmRvZmZFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSHAoKcHJpY2luZ19pZBgCIAEoCUII2tgYBAoCKAESJQoHcHJvZHVjdBgDIAEoCUIU2tgYEAoOGgxhcm1fNjAsZml4ZWQSEgoKYXR0ZW1wdF9pZBgEIAEoCRIcCgpoYW5kb2ZmX2lkGAYgASgJQgja2BgECgIoARJGCgdvdXRjb21lGAUgASgJQjXa2BgxCi8aLWF0dGVtcHRlZCxjcmVhdGVkLHN0YWxlLHVuYXZhaWxhYmxlLHJlYWRfb25seRrRBAoRVG91ckNhbmNlbGVkRXZlbnQSFAoMYWRkcmVzc191dWlkGAEgASgJEg8KB3RvdXJfaWQYAiABKAkSHAoKbGlzdGluZ19pZBgDIAEoCUII2tgYBAoCKAESMQoNc2NoZWR1bGVkX2ZvchgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIaXNfYWdlbnQYBSABKAgSbgoOYm9va2luZ19zb3VyY2UYBiABKA4yTC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuTWFya2V0cGxhY2VQcm9wZXJ0eUNhdGVnb3J5LkJvb2tpbmdTb3VyY2VCCOLYGAQqAggBEooBChNjYW5jZWxsYXRpb25fc291cmNlGAcgASgOMmMub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLk1hcmtldHBsYWNlUHJvcGVydHlDYXRlZ29yeS5Ub3VyQ2FuY2VsZWRFdmVudC5DYW5jZWxsYXRpb25Tb3VyY2VCCOLYGAQqAggBIq4BChJDYW5jZWxsYXRpb25Tb3VyY2USIwofQ0FOQ0VMTEFUSU9OX1NPVVJDRV9VTlNQRUNJRklFRBAAEg0KCVNFTEZfVE9VUhABEhAKDFNIT1dJTkdfVElNRRACEhIKDk9QRU5ET09SX0FETUlOEAMSEgoOTElTVElOR19TVEFUVVMQBBIMCghPUEVORE9PUhAFEgsKB1VOS05PV04QBhIPCgtCUk5fUkVQQUlSUxAHOgT42BgBGpYCChRUb3VyUmVzY2hlZHVsZWRFdmVudBIUCgxhZGRyZXNzX3V1aWQYASABKAkSDwoHdG91cl9pZBgCIAEoCRIcCgpsaXN0aW5nX2lkGAMgASgJQgja2BgECgIoARIxCg1zY2hlZHVsZWRfZm9yGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIQCghpc19hZ2VudBgFIAEoCBJuCg5ib29raW5nX3NvdXJjZRgGIAEoDjJMLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5NYXJrZXRwbGFjZVByb3BlcnR5Q2F0ZWdvcnkuQm9va2luZ1NvdXJjZUII4tgYBCoCCAE6BPjYGAEimQEKFVJlYWN0aW9uRXZlbnRSZWFjdGlvbhIYChRSRUFDVElPTl9VTlNQRUNJRklFRBAAEhUKEVJFQUNUSU9OX0FERF9MSUtFEAESGAoUUkVBQ1RJT05fUkVNT1ZFX0xJS0UQAhIYChRSRUFDVElPTl9BRERfRElTTElLRRADEhsKF1JFQUNUSU9OX1JFTU9WRV9ESVNMSUtFEAQivAEKEUxpc3RpbmdNZWRpYVN0YXRlEiMKH0xJU1RJTkdfTUVESUFfU1RBVEVfVU5TUEVDSUZJRUQQABIeChpMSVNUSU5HX01FRElBX1NUQVRFX1BIT1RPUxABEh0KGUxJU1RJTkdfTUVESUFfU1RBVEVfVklERU8QAhIfChtMSVNUSU5HX01FRElBX1NUQVRFX1RPVVJfM0QQAxIiCh5MSVNUSU5HX01FRElBX1NUQVRFX0ZMT09SX1BMQU4QBCKPAQoQVmVyaWZpY2F0aW9uU3RlcBIhCh1WRVJJRklDQVRJT05fU1RFUF9VTlNQRUNJRklFRBAAEhsKF1ZFUklGSUNBVElPTl9TVEVQX0xPR0lOEAESGwoXVkVSSUZJQ0FUSU9OX1NURVBfUEhPTkUQAhIeChpWRVJJRklDQVRJT05fU1RFUF9JREVOVElUWRADIqgBCg1Cb29raW5nU291cmNlEh4KGkJPT0tJTkdfU09VUkNFX1VOU1BFQ0lGSUVEEAASHwobQk9PS0lOR19TT1VSQ0VfSU5URVJOQUxfQVBJEAESHAoYQk9PS0lOR19TT1VSQ0VfTU9CSUxFX1YxEAISGAoUQk9PS0lOR19TT1VSQ0VfQURNSU4QAxIeChpCT09LSU5HX1NPVVJDRV9TSE9XSU5HVElNRRAEQgcKBWV2ZW50QkNaQWdpdGh1Yi5jb20vb3BlbmRvb3ItbGFicy9jb2RlL2dvL3Byb3RvYnVmL2pvdXJuZXkvZGF0YS9jYXRlZ29yaWVzYgZwcm90bzM", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_protobuf_journey_data_options_options]);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategory = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory"> & {
  /**
   * Next ID: 48
   *
   * @generated from oneof od_protos.journey.data.categories.MarketplacePropertyCategory.event
   */
  event: {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
     */
    value: MarketplacePropertyCategory_DetailPageViewEvent;
    case: "detailPageView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
     */
    value: MarketplacePropertyCategory_SimilarHomesClickEvent;
    case: "similarHomesClick";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
     */
    value: MarketplacePropertyCategory_TourBookingStartEvent;
    case: "tourBookingStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
     */
    value: MarketplacePropertyCategory_ReactionEvent;
    case: "reaction";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
     */
    value: MarketplacePropertyCategory_OfferStartEvent;
    case: "offerStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
     */
    value: MarketplacePropertyCategory_ShareEvent;
    case: "share";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
     */
    value: MarketplacePropertyCategory_RentalScamBannerViewEvent;
    case: "rentalScamBannerView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
     */
    value: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent;
    case: "rentalScamBannerLearnMore";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
     */
    value: MarketplacePropertyCategory_NaturalLanguageSearchEvent;
    case: "naturalLanguageSearch";
  } | {
    /**
     * Tour booking funnel
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
     */
    value: MarketplacePropertyCategory_TourFlowStartedEvent;
    case: "tourFlowStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
     */
    value: MarketplacePropertyCategory_TourSlotSelectedEvent;
    case: "tourSlotSelected";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
     */
    value: MarketplacePropertyCategory_TourVerificationStartedEvent;
    case: "tourVerificationStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
     */
    value: MarketplacePropertyCategory_TourVerificationCompletedEvent;
    case: "tourVerificationCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
     */
    value: MarketplacePropertyCategory_TourBookingAttemptedEvent;
    case: "tourBookingAttempted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
     */
    value: MarketplacePropertyCategory_TourBookingCompletedEvent;
    case: "tourBookingCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
     */
    value: MarketplacePropertyCategory_TourFlowAbandonedEvent;
    case: "tourFlowAbandoned";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
     */
    value: MarketplacePropertyCategory_IdvSessionDeniedEvent;
    case: "idvSessionDenied";
  } | {
    /**
     * Tour management
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
     */
    value: MarketplacePropertyCategory_TourCancelConfirmedEvent;
    case: "tourCancelConfirmed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
     */
    value: MarketplacePropertyCategory_TourCancelSucceededEvent;
    case: "tourCancelSucceeded";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
     */
    value: MarketplacePropertyCategory_TourFeedbackSubmittedEvent;
    case: "tourFeedbackSubmitted";
  } | {
    /**
     * Tour entry
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
     */
    value: MarketplacePropertyCategory_AccessCodeLoadedEvent;
    case: "accessCodeLoaded";
  } | {
    /**
     * Search
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
     */
    value: MarketplacePropertyCategory_SearchResultSelectedEvent;
    case: "searchResultSelected";
  } | {
    /**
     * Globe usage
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
     */
    value: MarketplacePropertyCategory_MapGlobeEnteredEvent;
    case: "mapGlobeEntered";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
     */
    value: MarketplacePropertyCategory_MapGlobeExitedEvent;
    case: "mapGlobeExited";
  } | {
    /**
     * Carousel engagement
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
     */
    value: MarketplacePropertyCategory_CarouselEngagementEvent;
    case: "carouselEngagement";
  } | {
    /**
     * Buyer conversion signals
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
     */
    value: MarketplacePropertyCategory_PropertySearchEvent;
    case: "propertySearch";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
     */
    value: MarketplacePropertyCategory_AddFavoriteEvent;
    case: "addFavorite";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
     */
    value: MarketplacePropertyCategory_OfferSubmittedEvent;
    case: "offerSubmitted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
     */
    value: MarketplacePropertyCategory_AccountCreatedEvent;
    case: "accountCreated";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
     */
    value: MarketplacePropertyCategory_TourScheduledEvent;
    case: "tourScheduled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
     */
    value: MarketplacePropertyCategory_TourCompletedEvent;
    case: "tourCompleted";
  } | {
    /**
     * Certainty panel (PDP)
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent certainty_panel_view = 32;
     */
    value: MarketplacePropertyCategory_CertaintyPanelViewEvent;
    case: "certaintyPanelView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent certainty_panel_click = 33;
     */
    value: MarketplacePropertyCategory_CertaintyPanelClickEvent;
    case: "certaintyPanelClick";
  } | {
    /**
     * Media slot (PDP)
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent listing_media_impression = 34;
     */
    value: MarketplacePropertyCategory_ListingMediaImpressionEvent;
    case: "listingMediaImpression";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent listing_media_toggle = 35;
     */
    value: MarketplacePropertyCategory_ListingMediaToggleEvent;
    case: "listingMediaToggle";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent listing_video_playback = 36;
     */
    value: MarketplacePropertyCategory_ListingVideoPlaybackEvent;
    case: "listingVideoPlayback";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent offer_checkout_step = 37;
     */
    value: MarketplacePropertyCategory_OfferCheckoutStepEvent;
    case: "offerCheckoutStep";
  } | {
    /**
     * Tour lifecycle
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent tour_canceled = 38;
     */
    value: MarketplacePropertyCategory_TourCanceledEvent;
    case: "tourCanceled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent tour_rescheduled = 39;
     */
    value: MarketplacePropertyCategory_TourRescheduledEvent;
    case: "tourRescheduled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent customer_property_save_changed = 40;
     */
    value: MarketplacePropertyCategory_CustomerPropertySaveChangedEvent;
    case: "customerPropertySaveChanged";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent get_preapproved_click = 41;
     */
    value: MarketplacePropertyCategory_GetPreapprovedClickEvent;
    case: "getPreapprovedClick";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent drop_state_viewed = 42;
     */
    value: MarketplacePropertyCategory_DropStateViewedEvent;
    case: "dropStateViewed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent drop_offer_viewed = 43;
     */
    value: MarketplacePropertyCategory_DropOfferViewedEvent;
    case: "dropOfferViewed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent tour_flow_step_viewed = 44;
     */
    value: MarketplacePropertyCategory_TourFlowStepViewedEvent;
    case: "tourFlowStepViewed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent tour_flow_failed = 45;
     */
    value: MarketplacePropertyCategory_TourFlowFailedEvent;
    case: "tourFlowFailed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent drop_preapproval_handoff = 46;
     */
    value: MarketplacePropertyCategory_DropPreapprovalHandoffEvent;
    case: "dropPreapprovalHandoff";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent listing_offer_received = 47;
     */
    value: MarketplacePropertyCategory_ListingOfferReceivedEvent;
    case: "listingOfferReceived";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategoryJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
   */
  detailPageView?: MarketplacePropertyCategory_DetailPageViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
   */
  similarHomesClick?: MarketplacePropertyCategory_SimilarHomesClickEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
   */
  tourBookingStart?: MarketplacePropertyCategory_TourBookingStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
   */
  offerStart?: MarketplacePropertyCategory_OfferStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
   */
  share?: MarketplacePropertyCategory_ShareEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
   */
  rentalScamBannerView?: MarketplacePropertyCategory_RentalScamBannerViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
   */
  rentalScamBannerLearnMore?: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
   */
  naturalLanguageSearch?: MarketplacePropertyCategory_NaturalLanguageSearchEventJson;

  /**
   * Tour booking funnel
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
   */
  tourFlowStarted?: MarketplacePropertyCategory_TourFlowStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
   */
  tourSlotSelected?: MarketplacePropertyCategory_TourSlotSelectedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
   */
  tourVerificationStarted?: MarketplacePropertyCategory_TourVerificationStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
   */
  tourVerificationCompleted?: MarketplacePropertyCategory_TourVerificationCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
   */
  tourBookingAttempted?: MarketplacePropertyCategory_TourBookingAttemptedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
   */
  tourBookingCompleted?: MarketplacePropertyCategory_TourBookingCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
   */
  tourFlowAbandoned?: MarketplacePropertyCategory_TourFlowAbandonedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
   */
  idvSessionDenied?: MarketplacePropertyCategory_IdvSessionDeniedEventJson;

  /**
   * Tour management
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
   */
  tourCancelConfirmed?: MarketplacePropertyCategory_TourCancelConfirmedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
   */
  tourCancelSucceeded?: MarketplacePropertyCategory_TourCancelSucceededEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
   */
  tourFeedbackSubmitted?: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson;

  /**
   * Tour entry
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
   */
  accessCodeLoaded?: MarketplacePropertyCategory_AccessCodeLoadedEventJson;

  /**
   * Search
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
   */
  searchResultSelected?: MarketplacePropertyCategory_SearchResultSelectedEventJson;

  /**
   * Globe usage
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
   */
  mapGlobeEntered?: MarketplacePropertyCategory_MapGlobeEnteredEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
   */
  mapGlobeExited?: MarketplacePropertyCategory_MapGlobeExitedEventJson;

  /**
   * Carousel engagement
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
   */
  carouselEngagement?: MarketplacePropertyCategory_CarouselEngagementEventJson;

  /**
   * Buyer conversion signals
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
   */
  propertySearch?: MarketplacePropertyCategory_PropertySearchEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
   */
  addFavorite?: MarketplacePropertyCategory_AddFavoriteEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
   */
  offerSubmitted?: MarketplacePropertyCategory_OfferSubmittedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
   */
  accountCreated?: MarketplacePropertyCategory_AccountCreatedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
   */
  tourScheduled?: MarketplacePropertyCategory_TourScheduledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
   */
  tourCompleted?: MarketplacePropertyCategory_TourCompletedEventJson;

  /**
   * Certainty panel (PDP)
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent certainty_panel_view = 32;
   */
  certaintyPanelView?: MarketplacePropertyCategory_CertaintyPanelViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent certainty_panel_click = 33;
   */
  certaintyPanelClick?: MarketplacePropertyCategory_CertaintyPanelClickEventJson;

  /**
   * Media slot (PDP)
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent listing_media_impression = 34;
   */
  listingMediaImpression?: MarketplacePropertyCategory_ListingMediaImpressionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent listing_media_toggle = 35;
   */
  listingMediaToggle?: MarketplacePropertyCategory_ListingMediaToggleEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent listing_video_playback = 36;
   */
  listingVideoPlayback?: MarketplacePropertyCategory_ListingVideoPlaybackEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent offer_checkout_step = 37;
   */
  offerCheckoutStep?: MarketplacePropertyCategory_OfferCheckoutStepEventJson;

  /**
   * Tour lifecycle
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent tour_canceled = 38;
   */
  tourCanceled?: MarketplacePropertyCategory_TourCanceledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent tour_rescheduled = 39;
   */
  tourRescheduled?: MarketplacePropertyCategory_TourRescheduledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent customer_property_save_changed = 40;
   */
  customerPropertySaveChanged?: MarketplacePropertyCategory_CustomerPropertySaveChangedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent get_preapproved_click = 41;
   */
  getPreapprovedClick?: MarketplacePropertyCategory_GetPreapprovedClickEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent drop_state_viewed = 42;
   */
  dropStateViewed?: MarketplacePropertyCategory_DropStateViewedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent drop_offer_viewed = 43;
   */
  dropOfferViewed?: MarketplacePropertyCategory_DropOfferViewedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent tour_flow_step_viewed = 44;
   */
  tourFlowStepViewed?: MarketplacePropertyCategory_TourFlowStepViewedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent tour_flow_failed = 45;
   */
  tourFlowFailed?: MarketplacePropertyCategory_TourFlowFailedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent drop_preapproval_handoff = 46;
   */
  dropPreapprovalHandoff?: MarketplacePropertyCategory_DropPreapprovalHandoffEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent listing_offer_received = 47;
   */
  listingOfferReceived?: MarketplacePropertyCategory_ListingOfferReceivedEventJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.
 * Use `create(MarketplacePropertyCategorySchema)` to create a new message.
 */
export const MarketplacePropertyCategorySchema: GenMessage<MarketplacePropertyCategory, {jsonType: MarketplacePropertyCategoryJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent.
 * Use `create(MarketplacePropertyCategory_DetailPageViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DetailPageViewEventSchema: GenMessage<MarketplacePropertyCategory_DetailPageViewEvent, {jsonType: MarketplacePropertyCategory_DetailPageViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent.
 * Use `create(MarketplacePropertyCategory_SimilarHomesClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SimilarHomesClickEventSchema: GenMessage<MarketplacePropertyCategory_SimilarHomesClickEvent, {jsonType: MarketplacePropertyCategory_SimilarHomesClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingStartEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingStartEvent, {jsonType: MarketplacePropertyCategory_TourBookingStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction: MarketplacePropertyCategory_ReactionEventReaction;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventReactionJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent.
 * Use `create(MarketplacePropertyCategory_ReactionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ReactionEventSchema: GenMessage<MarketplacePropertyCategory_ReactionEvent, {jsonType: MarketplacePropertyCategory_ReactionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent.
 * Use `create(MarketplacePropertyCategory_OfferStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferStartEventSchema: GenMessage<MarketplacePropertyCategory_OfferStartEvent, {jsonType: MarketplacePropertyCategory_OfferStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 4);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent.
 * Use `create(MarketplacePropertyCategory_ShareEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ShareEventSchema: GenMessage<MarketplacePropertyCategory_ShareEvent, {jsonType: MarketplacePropertyCategory_ShareEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 5);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerViewEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerViewEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 6);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 7);

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface: MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName: string;

  /**
   * @generated from field: string market = 4;
   */
  market: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: number | undefined;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: number | undefined;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs: bigint;
};

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEventJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface?: MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName?: string;

  /**
   * @generated from field: string market = 4;
   */
  market?: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded?: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: Int32ValueJson;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: Int32ValueJson;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned?: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason?: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated?: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.
 * Use `create(MarketplacePropertyCategory_NaturalLanguageSearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEventSchema: GenMessage<MarketplacePropertyCategory_NaturalLanguageSearchEvent, {jsonType: MarketplacePropertyCategory_NaturalLanguageSearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8);

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export enum MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface {
  /**
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  SURFACE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STANDALONE = 1;
   */
  STANDALONE = 1,

  /**
   * @generated from enum value: MAP_CLUSTERS = 2;
   */
  MAP_CLUSTERS = 2,

  /**
   * @generated from enum value: MAP_PINS = 3;
   */
  MAP_PINS = 3,
}

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson = "SURFACE_UNSPECIFIED" | "STANDALONE" | "MAP_CLUSTERS" | "MAP_PINS";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceSchema: GenEnum<MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface, MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8, 0);

/**
 * Tour booking funnel. Web collects a phone number before reserving a tour;
 * phone and identity verification remain separate app steps.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified: boolean;

  /**
   * @generated from field: string flow_id = 4;
   */
  flowId: string;

  /**
   * Legacy clients omit these flags. Absence leaves their observed values
   * unchanged; false means the paired boolean is unknown, true means known.
   *
   * @generated from field: google.protobuf.BoolValue availability_loaded = 5;
   */
  availabilityLoaded?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue eligibility_loaded = 6;
   */
  eligibilityLoaded?: boolean | undefined;
};

/**
 * Tour booking funnel. Web collects a phone number before reserving a tour;
 * phone and identity verification remain separate app steps.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow?: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified?: boolean;

  /**
   * @generated from field: string flow_id = 4;
   */
  flowId?: string;

  /**
   * Legacy clients omit these flags. Absence leaves their observed values
   * unchanged; false means the paired boolean is unknown, true means known.
   *
   * @generated from field: google.protobuf.BoolValue availability_loaded = 5;
   */
  availabilityLoaded?: BoolValueJson;

  /**
   * @generated from field: google.protobuf.BoolValue eligibility_loaded = 6;
   */
  eligibilityLoaded?: BoolValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowStartedEvent, {jsonType: MarketplacePropertyCategory_TourFlowStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 9);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup;

  /**
   * @generated from field: string flow_id = 5;
   */
  flowId: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup?: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson;

  /**
   * @generated from field: string flow_id = 5;
   */
  flowId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.
 * Use `create(MarketplacePropertyCategory_TourSlotSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEventSchema: GenMessage<MarketplacePropertyCategory_TourSlotSelectedEvent, {jsonType: MarketplacePropertyCategory_TourSlotSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export enum MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup {
  /**
   * @generated from enum value: TIME_GROUP_UNSPECIFIED = 0;
   */
  TIME_GROUP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MORNING = 1;
   */
  MORNING = 1,

  /**
   * @generated from enum value: AFTERNOON = 2;
   */
  AFTERNOON = 2,

  /**
   * @generated from enum value: EVENING = 3;
   */
  EVENING = 3,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson = "TIME_GROUP_UNSPECIFIED" | "MORNING" | "AFTERNOON" | "EVENING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupSchema: GenEnum<MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup, MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationStartedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 11);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: number | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: Int32ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationCompletedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 12);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;

  /**
   * @generated from field: string flow_id = 3;
   */
  flowId: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;

  /**
   * @generated from field: string flow_id = 3;
   */
  flowId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingAttemptedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingAttemptedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingAttemptedEvent, {jsonType: MarketplacePropertyCategory_TourBookingAttemptedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 13);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: number | undefined;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount: number;

  /**
   * @generated from field: string flow_id = 6;
   */
  flowId: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime?: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: Int32ValueJson;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount?: number;

  /**
   * @generated from field: string flow_id = 6;
   */
  flowId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingCompletedEvent, {jsonType: MarketplacePropertyCategory_TourBookingCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 14);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected: boolean;

  /**
   * @generated from field: string flow_id = 4;
   */
  flowId: string;

  /**
   * An exit while the reservation request is pending is not proof that no
   * reservation was created. Join any later outcome using flow_id.
   *
   * @generated from field: bool booking_pending = 5;
   */
  bookingPending: boolean;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep?: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected?: boolean;

  /**
   * @generated from field: string flow_id = 4;
   */
  flowId?: string;

  /**
   * An exit while the reservation request is pending is not proof that no
   * reservation was created. Join any later outcome using flow_id.
   *
   * @generated from field: bool booking_pending = 5;
   */
  bookingPending?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowAbandonedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowAbandonedEvent, {jsonType: MarketplacePropertyCategory_TourFlowAbandonedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15);

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export enum MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep {
  /**
   * @generated from enum value: FLOW_STEP_UNSPECIFIED = 0;
   */
  FLOW_STEP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_SELECTION = 1;
   */
  TIME_SELECTION = 1,

  /**
   * @generated from enum value: LOGIN = 2;
   */
  LOGIN = 2,

  /**
   * @generated from enum value: PHONE_VERIFICATION = 3;
   */
  PHONE_VERIFICATION = 3,

  /**
   * @generated from enum value: ID_VERIFICATION = 4;
   */
  ID_VERIFICATION = 4,

  /**
   * @generated from enum value: REVIEW = 5;
   */
  REVIEW = 5,

  /**
   * @generated from enum value: CONFIRMATION = 6;
   */
  CONFIRMATION = 6,

  /**
   * @generated from enum value: PHONE_NUMBER_COLLECTION = 7;
   */
  PHONE_NUMBER_COLLECTION = 7,

  /**
   * @generated from enum value: CONTACT_SUPPORT = 8;
   */
  CONTACT_SUPPORT = 8,

  /**
   * @generated from enum value: AVAILABILITY_LOADING = 9;
   */
  AVAILABILITY_LOADING = 9,

  /**
   * @generated from enum value: AVAILABILITY_ERROR = 10;
   */
  AVAILABILITY_ERROR = 10,

  /**
   * @generated from enum value: ELIGIBILITY_LOADING = 11;
   */
  ELIGIBILITY_LOADING = 11,

  /**
   * @generated from enum value: BOOKING = 12;
   */
  BOOKING = 12,
}

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson = "FLOW_STEP_UNSPECIFIED" | "TIME_SELECTION" | "LOGIN" | "PHONE_VERIFICATION" | "ID_VERIFICATION" | "REVIEW" | "CONFIRMATION" | "PHONE_NUMBER_COLLECTION" | "CONTACT_SUPPORT" | "AVAILABILITY_LOADING" | "AVAILABILITY_ERROR" | "ELIGIBILITY_LOADING" | "BOOKING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepSchema: GenEnum<MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep, MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent
 */
export type MarketplacePropertyCategory_TourFlowStepViewedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string flow_id = 2;
   */
  flowId: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep step = 3;
   */
  step: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent
 */
export type MarketplacePropertyCategory_TourFlowStepViewedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string flow_id = 2;
   */
  flowId?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep step = 3;
   */
  step?: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStepViewedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowStepViewedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowStepViewedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowStepViewedEvent, {jsonType: MarketplacePropertyCategory_TourFlowStepViewedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 16);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent
 */
export type MarketplacePropertyCategory_TourFlowFailedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string flow_id = 2;
   */
  flowId: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep step = 3;
   */
  step: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.FailureReason reason = 4;
   */
  reason: MarketplacePropertyCategory_TourFlowFailedEvent_FailureReason;

  /**
   * Timeout and unknown client failures cannot establish the server outcome.
   *
   * @generated from field: bool booking_outcome_unknown = 5;
   */
  bookingOutcomeUnknown: boolean;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent
 */
export type MarketplacePropertyCategory_TourFlowFailedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string flow_id = 2;
   */
  flowId?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep step = 3;
   */
  step?: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.FailureReason reason = 4;
   */
  reason?: MarketplacePropertyCategory_TourFlowFailedEvent_FailureReasonJson;

  /**
   * Timeout and unknown client failures cannot establish the server outcome.
   *
   * @generated from field: bool booking_outcome_unknown = 5;
   */
  bookingOutcomeUnknown?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowFailedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowFailedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowFailedEvent, {jsonType: MarketplacePropertyCategory_TourFlowFailedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 17);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.FailureReason
 */
export enum MarketplacePropertyCategory_TourFlowFailedEvent_FailureReason {
  /**
   * @generated from enum value: FAILURE_REASON_UNSPECIFIED = 0;
   */
  FAILURE_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AVAILABILITY_REQUEST_FAILED = 1;
   */
  AVAILABILITY_REQUEST_FAILED = 1,

  /**
   * @generated from enum value: NO_AVAILABLE_SLOTS = 2;
   */
  NO_AVAILABLE_SLOTS = 2,

  /**
   * @generated from enum value: ELIGIBILITY_REQUEST_FAILED = 3;
   */
  ELIGIBILITY_REQUEST_FAILED = 3,

  /**
   * @generated from enum value: CONTACT_SUPPORT_REQUIRED = 4;
   */
  CONTACT_SUPPORT_REQUIRED = 4,

  /**
   * @generated from enum value: PHONE_SAVE_FAILED = 5;
   */
  PHONE_SAVE_FAILED = 5,

  /**
   * @generated from enum value: SLOT_UNAVAILABLE = 6;
   */
  SLOT_UNAVAILABLE = 6,

  /**
   * @generated from enum value: UNAUTHORIZED = 7;
   */
  UNAUTHORIZED = 7,

  /**
   * @generated from enum value: UNAUTHENTICATED = 8;
   */
  UNAUTHENTICATED = 8,

  /**
   * @generated from enum value: REAUTHENTICATION_REQUIRED = 9;
   */
  REAUTHENTICATION_REQUIRED = 9,

  /**
   * @generated from enum value: INVALID_INPUT = 10;
   */
  INVALID_INPUT = 10,

  /**
   * @generated from enum value: BOOKING_TIMEOUT = 11;
   */
  BOOKING_TIMEOUT = 11,

  /**
   * @generated from enum value: BOOKING_UNKNOWN = 12;
   */
  BOOKING_UNKNOWN = 12,

  /**
   * Availability returned slots without the timezone needed to display them.
   *
   * @generated from enum value: AVAILABILITY_TIMEZONE_MISSING = 13;
   */
  AVAILABILITY_TIMEZONE_MISSING = 13,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.FailureReason
 */
export type MarketplacePropertyCategory_TourFlowFailedEvent_FailureReasonJson = "FAILURE_REASON_UNSPECIFIED" | "AVAILABILITY_REQUEST_FAILED" | "NO_AVAILABLE_SLOTS" | "ELIGIBILITY_REQUEST_FAILED" | "CONTACT_SUPPORT_REQUIRED" | "PHONE_SAVE_FAILED" | "SLOT_UNAVAILABLE" | "UNAUTHORIZED" | "UNAUTHENTICATED" | "REAUTHENTICATION_REQUIRED" | "INVALID_INPUT" | "BOOKING_TIMEOUT" | "BOOKING_UNKNOWN" | "AVAILABILITY_TIMEZONE_MISSING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowFailedEvent.FailureReason.
 */
export const MarketplacePropertyCategory_TourFlowFailedEvent_FailureReasonSchema: GenEnum<MarketplacePropertyCategory_TourFlowFailedEvent_FailureReason, MarketplacePropertyCategory_TourFlowFailedEvent_FailureReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 17, 0);

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason;
};

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason?: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.
 * Use `create(MarketplacePropertyCategory_IdvSessionDeniedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEventSchema: GenMessage<MarketplacePropertyCategory_IdvSessionDeniedEvent, {jsonType: MarketplacePropertyCategory_IdvSessionDeniedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 18);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export enum MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason {
  /**
   * @generated from enum value: DENIAL_REASON_UNSPECIFIED = 0;
   */
  DENIAL_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALREADY_VERIFIED = 1;
   */
  ALREADY_VERIFIED = 1,

  /**
   * @generated from enum value: RETRY_THRESHOLD_REACHED = 2;
   */
  RETRY_THRESHOLD_REACHED = 2,

  /**
   * @generated from enum value: FEATURE_DISABLED = 3;
   */
  FEATURE_DISABLED = 3,

  /**
   * @generated from enum value: TIMED_OUT = 4;
   */
  TIMED_OUT = 4,

  /**
   * The server returned a reason this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 5;
   */
  UNKNOWN = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson = "DENIAL_REASON_UNSPECIFIED" | "ALREADY_VERIFIED" | "RETRY_THRESHOLD_REACHED" | "FEATURE_DISABLED" | "TIMED_OUT" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonSchema: GenEnum<MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason, MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 18, 0);

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelConfirmedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelConfirmedEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelConfirmedEvent, {jsonType: MarketplacePropertyCategory_TourCancelConfirmedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelSucceededEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelSucceededEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelSucceededEvent, {jsonType: MarketplacePropertyCategory_TourCancelSucceededEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 20);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource;

  /**
   * @generated from field: string tour_id = 4;
   */
  tourId: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson;

  /**
   * @generated from field: string tour_id = 4;
   */
  tourId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_TourFeedbackSubmittedEvent, {jsonType: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment {
  /**
   * @generated from enum value: SENTIMENT_UNSPECIFIED = 0;
   */
  SENTIMENT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: POSITIVE = 1;
   */
  POSITIVE = 1,

  /**
   * @generated from enum value: NEUTRAL = 2;
   */
  NEUTRAL = 2,

  /**
   * @generated from enum value: NEGATIVE = 3;
   */
  NEGATIVE = 3,

  /**
   * @generated from enum value: UNKNOWN = 4;
   */
  UNKNOWN = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson = "SENTIMENT_UNSPECIFIED" | "POSITIVE" | "NEUTRAL" | "NEGATIVE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21, 0);

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource {
  /**
   * @generated from enum value: FEEDBACK_SOURCE_UNSPECIFIED = 0;
   */
  FEEDBACK_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUICK = 1;
   */
  QUICK = 1,

  /**
   * @generated from enum value: DETAILED = 2;
   */
  DETAILED = 2,
}

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson = "FEEDBACK_SOURCE_UNSPECIFIED" | "QUICK" | "DETAILED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21, 1);

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType;
};

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType?: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.
 * Use `create(MarketplacePropertyCategory_AccessCodeLoadedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEventSchema: GenMessage<MarketplacePropertyCategory_AccessCodeLoadedEvent, {jsonType: MarketplacePropertyCategory_AccessCodeLoadedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 22);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export enum MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType {
  /**
   * @generated from enum value: SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0;
   */
  SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SMARTRENT = 1;
   */
  SMARTRENT = 1,

  /**
   * @generated from enum value: ARCO = 2;
   */
  ARCO = 2,

  /**
   * @generated from enum value: CLEMENTINE = 3;
   */
  CLEMENTINE = 3,

  /**
   * @generated from enum value: KNOX = 4;
   */
  KNOX = 4,

  /**
   * @generated from enum value: LINK = 5;
   */
  LINK = 5,

  /**
   * @generated from enum value: NONE = 6;
   */
  NONE = 6,

  /**
   * The server returned a vendor this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 7;
   */
  UNKNOWN = 7,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson = "SECURITY_SYSTEM_TYPE_UNSPECIFIED" | "SMARTRENT" | "ARCO" | "CLEMENTINE" | "KNOX" | "LINK" | "NONE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeSchema: GenEnum<MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType, MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 22, 0);

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition: number;
};

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType?: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength?: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.
 * Use `create(MarketplacePropertyCategory_SearchResultSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEventSchema: GenMessage<MarketplacePropertyCategory_SearchResultSelectedEvent, {jsonType: MarketplacePropertyCategory_SearchResultSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 23);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export enum MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType {
  /**
   * @generated from enum value: RESULT_TYPE_UNSPECIFIED = 0;
   */
  RESULT_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ZONE = 1;
   */
  ZONE = 1,

  /**
   * @generated from enum value: LISTING = 2;
   */
  LISTING = 2,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson = "RESULT_TYPE_UNSPECIFIED" | "ZONE" | "LISTING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeSchema: GenEnum<MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType, MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 23, 0);

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent"> & {
};

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEventJson = {
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeEnteredEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeEnteredEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeEnteredEvent, {jsonType: MarketplacePropertyCategory_MapGlobeEnteredEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 24);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent"> & {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm: number;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEventJson = {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs?: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged?: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeExitedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeExitedEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeExitedEvent, {jsonType: MarketplacePropertyCategory_MapGlobeExitedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 25);

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex: number;
};

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount?: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed?: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount?: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount?: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount?: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex?: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent.
 * Use `create(MarketplacePropertyCategory_CarouselEngagementEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CarouselEngagementEventSchema: GenMessage<MarketplacePropertyCategory_CarouselEngagementEvent, {jsonType: MarketplacePropertyCategory_CarouselEngagementEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 26);

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger: MarketplacePropertyCategory_PropertySearchEvent_Trigger;

  /**
   * @generated from field: string market = 2;
   */
  market: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: bigint | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: bigint | undefined;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort: string;

  /**
   * One-based results page the interaction loaded. Bare int because
   * emitters always know the page, so 0 means the search was not paged.
   *
   * @generated from field: int32 page = 9;
   */
  page: number;
};

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger?: MarketplacePropertyCategory_PropertySearchEvent_TriggerJson;

  /**
   * @generated from field: string market = 2;
   */
  market?: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount?: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: Int64ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: Int64ValueJson;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort?: string;

  /**
   * One-based results page the interaction loaded. Bare int because
   * emitters always know the page, so 0 means the search was not paged.
   *
   * @generated from field: int32 page = 9;
   */
  page?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.
 * Use `create(MarketplacePropertyCategory_PropertySearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_PropertySearchEventSchema: GenMessage<MarketplacePropertyCategory_PropertySearchEvent, {jsonType: MarketplacePropertyCategory_PropertySearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 27);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export enum MarketplacePropertyCategory_PropertySearchEvent_Trigger {
  /**
   * @generated from enum value: TRIGGER_UNSPECIFIED = 0;
   */
  TRIGGER_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILTER_APPLY = 1;
   */
  FILTER_APPLY = 1,

  /**
   * @generated from enum value: QUICK_FILTER = 2;
   */
  QUICK_FILTER = 2,

  /**
   * @generated from enum value: MAP_MOVE = 3;
   */
  MAP_MOVE = 3,

  /**
   * @generated from enum value: LOCATION_SELECT = 4;
   */
  LOCATION_SELECT = 4,

  /**
   * @generated from enum value: SAVED_SEARCH = 5;
   */
  SAVED_SEARCH = 5,

  /**
   * @generated from enum value: RESET = 6;
   */
  RESET = 6,

  /**
   * @generated from enum value: SORT_CHANGE = 7;
   */
  SORT_CHANGE = 7,

  /**
   * A results-page turn: the paginated nav or Show more. Both fetch
   * another slice of the same search, so they share one trigger; page
   * carries the depth.
   *
   * @generated from enum value: PAGE_CHANGE = 8;
   */
  PAGE_CHANGE = 8,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export type MarketplacePropertyCategory_PropertySearchEvent_TriggerJson = "TRIGGER_UNSPECIFIED" | "FILTER_APPLY" | "QUICK_FILTER" | "MAP_MOVE" | "LOCATION_SELECT" | "SAVED_SEARCH" | "RESET" | "SORT_CHANGE" | "PAGE_CHANGE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger.
 */
export const MarketplacePropertyCategory_PropertySearchEvent_TriggerSchema: GenEnum<MarketplacePropertyCategory_PropertySearchEvent_Trigger, MarketplacePropertyCategory_PropertySearchEvent_TriggerJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 27, 0);

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;
};

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent.
 * Use `create(MarketplacePropertyCategory_AddFavoriteEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AddFavoriteEventSchema: GenMessage<MarketplacePropertyCategory_AddFavoriteEvent, {jsonType: MarketplacePropertyCategory_AddFavoriteEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 28);

/**
 * Next ID: 6
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.Surface surface = 5;
   */
  surface: MarketplacePropertyCategory_OfferSubmittedEvent_Surface;
};

/**
 * Next ID: 6
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid?: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.Surface surface = 5;
   */
  surface?: MarketplacePropertyCategory_OfferSubmittedEvent_SurfaceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_OfferSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_OfferSubmittedEvent, {jsonType: MarketplacePropertyCategory_OfferSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 29);

/**
 * Where the offer was submitted. Buy Direct checkout leaves it unset.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.Surface
 */
export enum MarketplacePropertyCategory_OfferSubmittedEvent_Surface {
  /**
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  SURFACE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_OFFER_PORTAL_V2 = 1;
   */
  AGENT_OFFER_PORTAL_V2 = 1,
}

/**
 * Where the offer was submitted. Buy Direct checkout leaves it unset.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.Surface
 */
export type MarketplacePropertyCategory_OfferSubmittedEvent_SurfaceJson = "SURFACE_UNSPECIFIED" | "AGENT_OFFER_PORTAL_V2";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.Surface.
 */
export const MarketplacePropertyCategory_OfferSubmittedEvent_SurfaceSchema: GenEnum<MarketplacePropertyCategory_OfferSubmittedEvent_Surface, MarketplacePropertyCategory_OfferSubmittedEvent_SurfaceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 29, 0);

/**
 * A listing offer received by Opendoor. The event grain is listing offer and customer.
 * Replaces offer_submitted once checkout stops sending that event.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent
 */
export type MarketplacePropertyCategory_ListingOfferReceivedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;

  /**
   * listing_offers values, lowercase.
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string channel = 6;
   */
  channel: string;

  /**
   * @generated from field: bool is_counter = 7;
   */
  isCounter: boolean;
};

/**
 * A listing offer received by Opendoor. The event grain is listing offer and customer.
 * Replaces offer_submitted once checkout stops sending that event.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent
 */
export type MarketplacePropertyCategory_ListingOfferReceivedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid?: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;

  /**
   * listing_offers values, lowercase.
   *
   * @generated from field: string source = 5;
   */
  source?: string;

  /**
   * @generated from field: string channel = 6;
   */
  channel?: string;

  /**
   * @generated from field: bool is_counter = 7;
   */
  isCounter?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingOfferReceivedEvent.
 * Use `create(MarketplacePropertyCategory_ListingOfferReceivedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingOfferReceivedEventSchema: GenMessage<MarketplacePropertyCategory_ListingOfferReceivedEvent, {jsonType: MarketplacePropertyCategory_ListingOfferReceivedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 30);

/**
 * Authenticated Buy Direct checkout step view. Distinct from offer_start
 * (PDP CTA, including guests) and offer_submitted (offer created).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step step = 2;
   */
  step: MarketplacePropertyCategory_OfferCheckoutStepEvent_Step;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;
};

/**
 * Authenticated Buy Direct checkout step view. Distinct from offer_start
 * (PDP CTA, including guests) and offer_submitted (offer created).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step step = 2;
   */
  step?: MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.
 * Use `create(MarketplacePropertyCategory_OfferCheckoutStepEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferCheckoutStepEventSchema: GenMessage<MarketplacePropertyCategory_OfferCheckoutStepEvent, {jsonType: MarketplacePropertyCategory_OfferCheckoutStepEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 31);

/**
 * In-progress checkout nodes only. IDLE, CONFIRMATION, REDIRECT,
 * ACTIVE_OFFER_BLOCKED, IN_CONTRACT, and CREATE_* are not modeled.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step
 */
export enum MarketplacePropertyCategory_OfferCheckoutStepEvent_Step {
  /**
   * @generated from enum value: STEP_UNSPECIFIED = 0;
   */
  STEP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTACT_DETAILS = 1;
   */
  CONTACT_DETAILS = 1,

  /**
   * @generated from enum value: CONTINGENT_SALE = 2;
   */
  CONTINGENT_SALE = 2,

  /**
   * @generated from enum value: FUNDING_SOURCE = 3;
   */
  FUNDING_SOURCE = 3,

  /**
   * @generated from enum value: SCHEDULE_AND_LOGISTICS = 4;
   */
  SCHEDULE_AND_LOGISTICS = 4,

  /**
   * @generated from enum value: REVIEW_CONTRACT_DETAILS = 5;
   */
  REVIEW_CONTRACT_DETAILS = 5,

  /**
   * @generated from enum value: BACKUP_OFFER_DETAILS = 6;
   */
  BACKUP_OFFER_DETAILS = 6,

  /**
   * @generated from enum value: OFFER_DEADLINE = 7;
   */
  OFFER_DEADLINE = 7,
}

/**
 * In-progress checkout nodes only. IDLE, CONFIRMATION, REDIRECT,
 * ACTIVE_OFFER_BLOCKED, IN_CONTRACT, and CREATE_* are not modeled.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson = "STEP_UNSPECIFIED" | "CONTACT_DETAILS" | "CONTINGENT_SALE" | "FUNDING_SOURCE" | "SCHEDULE_AND_LOGISTICS" | "REVIEW_CONTRACT_DETAILS" | "BACKUP_OFFER_DETAILS" | "OFFER_DEADLINE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step.
 */
export const MarketplacePropertyCategory_OfferCheckoutStepEvent_StepSchema: GenEnum<MarketplacePropertyCategory_OfferCheckoutStepEvent_Step, MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 31, 0);

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod;
};

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod?: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.
 * Use `create(MarketplacePropertyCategory_AccountCreatedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccountCreatedEventSchema: GenMessage<MarketplacePropertyCategory_AccountCreatedEvent, {jsonType: MarketplacePropertyCategory_AccountCreatedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 32);

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export enum MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod {
  /**
   * @generated from enum value: AUTH_METHOD_UNSPECIFIED = 0;
   */
  AUTH_METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_PASSWORD = 1;
   */
  EMAIL_PASSWORD = 1,

  /**
   * @generated from enum value: LITE = 2;
   */
  LITE = 2,

  /**
   * @generated from enum value: GOOGLE = 3;
   */
  GOOGLE = 3,

  /**
   * @generated from enum value: FACEBOOK = 4;
   */
  FACEBOOK = 4,

  /**
   * @generated from enum value: SESSION_ALREADY_EXISTS = 5;
   */
  SESSION_ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: APPLE = 6;
   */
  APPLE = 6,
}

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export type MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson = "AUTH_METHOD_UNSPECIFIED" | "EMAIL_PASSWORD" | "LITE" | "GOOGLE" | "FACEBOOK" | "SESSION_ALREADY_EXISTS" | "APPLE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod.
 */
export const MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodSchema: GenEnum<MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod, MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 32, 0);

/**
 * A Rails viewing appointment was booked. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (client outcome).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * UNSPECIFIED is not rare: it covers every tour booked before web
   * recorded a source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;

  /**
   * Trippy reservation ID shared with client booking-completed events.
   * tour_id identifies the separate Rails viewing appointment.
   *
   * @generated from field: string booking_id = 7;
   */
  bookingId: string;
};

/**
 * A Rails viewing appointment was booked. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (client outcome).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * UNSPECIFIED is not rare: it covers every tour booked before web
   * recorded a source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;

  /**
   * Trippy reservation ID shared with client booking-completed events.
   * tour_id identifies the separate Rails viewing appointment.
   *
   * @generated from field: string booking_id = 7;
   */
  bookingId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent.
 * Use `create(MarketplacePropertyCategory_TourScheduledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourScheduledEventSchema: GenMessage<MarketplacePropertyCategory_TourScheduledEvent, {jsonType: MarketplacePropertyCategory_TourScheduledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 33);

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal;

  /**
   * See TourScheduledEvent.booking_source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 7;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;
};

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal?: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson;

  /**
   * See TourScheduledEvent.booking_source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 7;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourCompletedEvent, {jsonType: MarketplacePropertyCategory_TourCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 34);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export enum MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal {
  /**
   * @generated from enum value: COMPLETION_SIGNAL_UNSPECIFIED = 0;
   */
  COMPLETION_SIGNAL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSUMED_ELAPSED = 1;
   */
  ASSUMED_ELAPSED = 1,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export type MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson = "COMPLETION_SIGNAL_UNSPECIFIED" | "ASSUMED_ELAPSED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal.
 */
export const MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalSchema: GenEnum<MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal, MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 34, 0);

/**
 * The PDP certainty panel entered the viewport. Fired for both experiment
 * arms; variant distinguishes them (the control arm's panel stays hidden).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string variant = 2;
   */
  variant: string;
};

/**
 * The PDP certainty panel entered the viewport. Fired for both experiment
 * arms; variant distinguishes them (the control arm's panel stays hidden).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string variant = 2;
   */
  variant?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent.
 * Use `create(MarketplacePropertyCategory_CertaintyPanelViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CertaintyPanelViewEventSchema: GenMessage<MarketplacePropertyCategory_CertaintyPanelViewEvent, {jsonType: MarketplacePropertyCategory_CertaintyPanelViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 35);

/**
 * A CTA inside the PDP certainty panel was clicked.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row row = 2;
   */
  row: MarketplacePropertyCategory_CertaintyPanelClickEvent_Row;

  /**
   * Sub-CTA within the row (e.g. disclosures vs mortgage in the guarantee
   * row); absent when the row has a single action.
   *
   * @generated from field: string target = 3;
   */
  target: string;
};

/**
 * A CTA inside the PDP certainty panel was clicked.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row row = 2;
   */
  row?: MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson;

  /**
   * Sub-CTA within the row (e.g. disclosures vs mortgage in the guarantee
   * row); absent when the row has a single action.
   *
   * @generated from field: string target = 3;
   */
  target?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.
 * Use `create(MarketplacePropertyCategory_CertaintyPanelClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CertaintyPanelClickEventSchema: GenMessage<MarketplacePropertyCategory_CertaintyPanelClickEvent, {jsonType: MarketplacePropertyCategory_CertaintyPanelClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 36);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row
 */
export enum MarketplacePropertyCategory_CertaintyPanelClickEvent_Row {
  /**
   * @generated from enum value: ROW_UNSPECIFIED = 0;
   */
  ROW_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRICE_CUT = 1;
   */
  PRICE_CUT = 1,

  /**
   * @generated from enum value: MONTHLY_COST = 2;
   */
  MONTHLY_COST = 2,

  /**
   * @generated from enum value: KEYS_BY = 3;
   */
  KEYS_BY = 3,

  /**
   * @generated from enum value: GUARANTEE = 4;
   */
  GUARANTEE = 4,

  /**
   * @generated from enum value: ACTIVITY = 5;
   */
  ACTIVITY = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson = "ROW_UNSPECIFIED" | "PRICE_CUT" | "MONTHLY_COST" | "KEYS_BY" | "GUARANTEE" | "ACTIVITY";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row.
 */
export const MarketplacePropertyCategory_CertaintyPanelClickEvent_RowSchema: GenEnum<MarketplacePropertyCategory_CertaintyPanelClickEvent_Row, MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 36, 0);

/**
 * The PDP media slot settled on a state and rendered it. Fired for every
 * arm, control included: play rate and engagement are rates over this
 * event, so an arm that does not emit it has no denominator.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent
 */
export type MarketplacePropertyCategory_ListingMediaImpressionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState media_state = 2;
   */
  mediaState: MarketplacePropertyCategory_ListingMediaState;

  /**
   * Experiment that decided the state, absent when the slot rendered
   * outside any experiment.
   *
   * @generated from field: string experiment_key = 3;
   */
  experimentKey: string;

  /**
   * @generated from field: string variant = 4;
   */
  variant: string;
};

/**
 * The PDP media slot settled on a state and rendered it. Fired for every
 * arm, control included: play rate and engagement are rates over this
 * event, so an arm that does not emit it has no denominator.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent
 */
export type MarketplacePropertyCategory_ListingMediaImpressionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState media_state = 2;
   */
  mediaState?: MarketplacePropertyCategory_ListingMediaStateJson;

  /**
   * Experiment that decided the state, absent when the slot rendered
   * outside any experiment.
   *
   * @generated from field: string experiment_key = 3;
   */
  experimentKey?: string;

  /**
   * @generated from field: string variant = 4;
   */
  variant?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent.
 * Use `create(MarketplacePropertyCategory_ListingMediaImpressionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingMediaImpressionEventSchema: GenMessage<MarketplacePropertyCategory_ListingMediaImpressionEvent, {jsonType: MarketplacePropertyCategory_ListingMediaImpressionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 37);

/**
 * A viewer moved the media slot between states (e.g. the Video/Photos
 * toggle). Both endpoints are carried rather than a direction so the slot
 * stays measurable as states are added.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent
 */
export type MarketplacePropertyCategory_ListingMediaToggleEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState from_state = 2;
   */
  fromState: MarketplacePropertyCategory_ListingMediaState;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState to_state = 3;
   */
  toState: MarketplacePropertyCategory_ListingMediaState;
};

/**
 * A viewer moved the media slot between states (e.g. the Video/Photos
 * toggle). Both endpoints are carried rather than a direction so the slot
 * stays measurable as states are added.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent
 */
export type MarketplacePropertyCategory_ListingMediaToggleEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState from_state = 2;
   */
  fromState?: MarketplacePropertyCategory_ListingMediaStateJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState to_state = 3;
   */
  toState?: MarketplacePropertyCategory_ListingMediaStateJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent.
 * Use `create(MarketplacePropertyCategory_ListingMediaToggleEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingMediaToggleEventSchema: GenMessage<MarketplacePropertyCategory_ListingMediaToggleEvent, {jsonType: MarketplacePropertyCategory_ListingMediaToggleEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 38);

/**
 * One event per playback milestone reached, so play rate and completion are
 * both rates over ListingMediaImpressionEvent rather than separate funnels.
 * A milestone fires at most once per playback session; seeking past one
 * still reports it, at the position playback landed on. A session ends at
 * COMPLETE or when the listing changes, so resuming from a pause continues
 * the current session rather than starting another one.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone milestone = 2;
   */
  milestone: MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone;

  /**
   * Wrappers rather than bare ints: a milestone reported before metadata
   * loads has no position, which a real 0 must stay distinguishable from.
   *
   * @generated from field: google.protobuf.Int32Value position_seconds = 3;
   */
  positionSeconds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value duration_seconds = 4;
   */
  durationSeconds?: number | undefined;
};

/**
 * One event per playback milestone reached, so play rate and completion are
 * both rates over ListingMediaImpressionEvent rather than separate funnels.
 * A milestone fires at most once per playback session; seeking past one
 * still reports it, at the position playback landed on. A session ends at
 * COMPLETE or when the listing changes, so resuming from a pause continues
 * the current session rather than starting another one.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone milestone = 2;
   */
  milestone?: MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson;

  /**
   * Wrappers rather than bare ints: a milestone reported before metadata
   * loads has no position, which a real 0 must stay distinguishable from.
   *
   * @generated from field: google.protobuf.Int32Value position_seconds = 3;
   */
  positionSeconds?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value duration_seconds = 4;
   */
  durationSeconds?: Int32ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.
 * Use `create(MarketplacePropertyCategory_ListingVideoPlaybackEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingVideoPlaybackEventSchema: GenMessage<MarketplacePropertyCategory_ListingVideoPlaybackEvent, {jsonType: MarketplacePropertyCategory_ListingVideoPlaybackEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 39);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone
 */
export enum MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone {
  /**
   * @generated from enum value: MILESTONE_UNSPECIFIED = 0;
   */
  MILESTONE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAY_START = 1;
   */
  PLAY_START = 1,

  /**
   * @generated from enum value: QUARTILE_25 = 2;
   */
  QUARTILE_25 = 2,

  /**
   * @generated from enum value: QUARTILE_50 = 3;
   */
  QUARTILE_50 = 3,

  /**
   * @generated from enum value: QUARTILE_75 = 4;
   */
  QUARTILE_75 = 4,

  /**
   * @generated from enum value: COMPLETE = 5;
   */
  COMPLETE = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson = "MILESTONE_UNSPECIFIED" | "PLAY_START" | "QUARTILE_25" | "QUARTILE_50" | "QUARTILE_75" | "COMPLETE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone.
 */
export const MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneSchema: GenEnum<MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone, MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 39, 0);

/**
 * Whether a property is saved to the customer profile, including merges and replay.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent
 */
export type MarketplacePropertyCategory_CustomerPropertySaveChangedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: google.protobuf.BoolValue is_saved = 2;
   */
  isSaved?: boolean | undefined;
};

/**
 * Whether a property is saved to the customer profile, including merges and replay.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent
 */
export type MarketplacePropertyCategory_CustomerPropertySaveChangedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: google.protobuf.BoolValue is_saved = 2;
   */
  isSaved?: BoolValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CustomerPropertySaveChangedEvent.
 * Use `create(MarketplacePropertyCategory_CustomerPropertySaveChangedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CustomerPropertySaveChangedEventSchema: GenMessage<MarketplacePropertyCategory_CustomerPropertySaveChangedEvent, {jsonType: MarketplacePropertyCategory_CustomerPropertySaveChangedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 40);

/**
 * "Get preapproved" click on a home's financing offer. A named ad conversion: GTM
 * and Segment map it by event name and dedup the pixel against it on client_event_id.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent
 */
export type MarketplacePropertyCategory_GetPreapprovedClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * "Get preapproved" click on a home's financing offer. A named ad conversion: GTM
 * and Segment map it by event name and dedup the pixel against it on client_event_id.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent
 */
export type MarketplacePropertyCategory_GetPreapprovedClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.GetPreapprovedClickEvent.
 * Use `create(MarketplacePropertyCategory_GetPreapprovedClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_GetPreapprovedClickEventSchema: GenMessage<MarketplacePropertyCategory_GetPreapprovedClickEvent, {jsonType: MarketplacePropertyCategory_GetPreapprovedClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 41);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent
 */
export type MarketplacePropertyCategory_DropStateViewedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: google.protobuf.Int32Value eligible_homes = 2;
   */
  eligibleHomes?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value results_count = 3;
   */
  resultsCount?: number | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp release_at = 4;
   */
  releaseAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp offer_expires_at = 5;
   */
  offerExpiresAt?: Timestamp | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent
 */
export type MarketplacePropertyCategory_DropStateViewedEventJson = {
  /**
   * @generated from field: string state = 1;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.Int32Value eligible_homes = 2;
   */
  eligibleHomes?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value results_count = 3;
   */
  resultsCount?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Timestamp release_at = 4;
   */
  releaseAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp offer_expires_at = 5;
   */
  offerExpiresAt?: TimestampJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DropStateViewedEvent.
 * Use `create(MarketplacePropertyCategory_DropStateViewedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DropStateViewedEventSchema: GenMessage<MarketplacePropertyCategory_DropStateViewedEvent, {jsonType: MarketplacePropertyCategory_DropStateViewedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 42);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent
 */
export type MarketplacePropertyCategory_DropOfferViewedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string pricing_id = 2;
   */
  pricingId: string;

  /**
   * @generated from field: string product = 3;
   */
  product: string;

  /**
   * @generated from field: string placement = 4;
   */
  placement: string;

  /**
   * @generated from field: int32 position = 5;
   */
  position: number;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 6;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: google.protobuf.DoubleValue rate_percent = 7;
   */
  ratePercent?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value principal_and_interest_cents = 8;
   */
  principalAndInterestCents?: bigint | undefined;

  /**
   * @generated from field: bool incentive = 9;
   */
  incentive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp offer_expires_at = 10;
   */
  offerExpiresAt?: Timestamp | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent
 */
export type MarketplacePropertyCategory_DropOfferViewedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string pricing_id = 2;
   */
  pricingId?: string;

  /**
   * @generated from field: string product = 3;
   */
  product?: string;

  /**
   * @generated from field: string placement = 4;
   */
  placement?: string;

  /**
   * @generated from field: int32 position = 5;
   */
  position?: number;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 6;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: google.protobuf.DoubleValue rate_percent = 7;
   */
  ratePercent?: DoubleValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value principal_and_interest_cents = 8;
   */
  principalAndInterestCents?: Int64ValueJson;

  /**
   * @generated from field: bool incentive = 9;
   */
  incentive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp offer_expires_at = 10;
   */
  offerExpiresAt?: TimestampJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DropOfferViewedEvent.
 * Use `create(MarketplacePropertyCategory_DropOfferViewedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DropOfferViewedEventSchema: GenMessage<MarketplacePropertyCategory_DropOfferViewedEvent, {jsonType: MarketplacePropertyCategory_DropOfferViewedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 43);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent
 */
export type MarketplacePropertyCategory_DropPreapprovalHandoffEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string pricing_id = 2;
   */
  pricingId: string;

  /**
   * @generated from field: string product = 3;
   */
  product: string;

  /**
   * Random per attempt; never the mortgage link's public access code.
   *
   * @generated from field: string attempt_id = 4;
   */
  attemptId: string;

  /**
   * Reuses the mortgage API idempotency key for warehouse joins across retries.
   *
   * @generated from field: string handoff_id = 6;
   */
  handoffId: string;

  /**
   * @generated from field: string outcome = 5;
   */
  outcome: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent
 */
export type MarketplacePropertyCategory_DropPreapprovalHandoffEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string pricing_id = 2;
   */
  pricingId?: string;

  /**
   * @generated from field: string product = 3;
   */
  product?: string;

  /**
   * Random per attempt; never the mortgage link's public access code.
   *
   * @generated from field: string attempt_id = 4;
   */
  attemptId?: string;

  /**
   * Reuses the mortgage API idempotency key for warehouse joins across retries.
   *
   * @generated from field: string handoff_id = 6;
   */
  handoffId?: string;

  /**
   * @generated from field: string outcome = 5;
   */
  outcome?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DropPreapprovalHandoffEvent.
 * Use `create(MarketplacePropertyCategory_DropPreapprovalHandoffEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DropPreapprovalHandoffEventSchema: GenMessage<MarketplacePropertyCategory_DropPreapprovalHandoffEvent, {jsonType: MarketplacePropertyCategory_DropPreapprovalHandoffEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 44);

/**
 * A Rails viewing appointment was canceled. This authoritative lifecycle
 * outcome is distinct from the iOS cancel-confirmed and cancel-succeeded
 * interaction events.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent
 */
export type MarketplacePropertyCategory_TourCanceledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource cancellation_source = 7;
   */
  cancellationSource: MarketplacePropertyCategory_TourCanceledEvent_CancellationSource;
};

/**
 * A Rails viewing appointment was canceled. This authoritative lifecycle
 * outcome is distinct from the iOS cancel-confirmed and cancel-succeeded
 * interaction events.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent
 */
export type MarketplacePropertyCategory_TourCanceledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource cancellation_source = 7;
   */
  cancellationSource?: MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.
 * Use `create(MarketplacePropertyCategory_TourCanceledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCanceledEventSchema: GenMessage<MarketplacePropertyCategory_TourCanceledEvent, {jsonType: MarketplacePropertyCategory_TourCanceledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 45);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource
 */
export enum MarketplacePropertyCategory_TourCanceledEvent_CancellationSource {
  /**
   * @generated from enum value: CANCELLATION_SOURCE_UNSPECIFIED = 0;
   */
  CANCELLATION_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SELF_TOUR = 1;
   */
  SELF_TOUR = 1,

  /**
   * @generated from enum value: SHOWING_TIME = 2;
   */
  SHOWING_TIME = 2,

  /**
   * @generated from enum value: OPENDOOR_ADMIN = 3;
   */
  OPENDOOR_ADMIN = 3,

  /**
   * @generated from enum value: LISTING_STATUS = 4;
   */
  LISTING_STATUS = 4,

  /**
   * @generated from enum value: OPENDOOR = 5;
   */
  OPENDOOR = 5,

  /**
   * @generated from enum value: UNKNOWN = 6;
   */
  UNKNOWN = 6,

  /**
   * Buyer repair negotiation repairs started on a home under contract.
   *
   * @generated from enum value: BRN_REPAIRS = 7;
   */
  BRN_REPAIRS = 7,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource
 */
export type MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson = "CANCELLATION_SOURCE_UNSPECIFIED" | "SELF_TOUR" | "SHOWING_TIME" | "OPENDOOR_ADMIN" | "LISTING_STATUS" | "OPENDOOR" | "UNKNOWN" | "BRN_REPAIRS";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource.
 */
export const MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceSchema: GenEnum<MarketplacePropertyCategory_TourCanceledEvent_CancellationSource, MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 45, 0);

/**
 * A Rails viewing appointment was moved to a new time while retaining its
 * appointment identity.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent
 */
export type MarketplacePropertyCategory_TourRescheduledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;
};

/**
 * A Rails viewing appointment was moved to a new time while retaining its
 * appointment identity.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent
 */
export type MarketplacePropertyCategory_TourRescheduledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent.
 * Use `create(MarketplacePropertyCategory_TourRescheduledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourRescheduledEventSchema: GenMessage<MarketplacePropertyCategory_TourRescheduledEvent, {jsonType: MarketplacePropertyCategory_TourRescheduledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 46);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export enum MarketplacePropertyCategory_ReactionEventReaction {
  /**
   * @generated from enum value: REACTION_UNSPECIFIED = 0;
   */
  REACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REACTION_ADD_LIKE = 1;
   */
  REACTION_ADD_LIKE = 1,

  /**
   * @generated from enum value: REACTION_REMOVE_LIKE = 2;
   */
  REACTION_REMOVE_LIKE = 2,

  /**
   * @generated from enum value: REACTION_ADD_DISLIKE = 3;
   */
  REACTION_ADD_DISLIKE = 3,

  /**
   * @generated from enum value: REACTION_REMOVE_DISLIKE = 4;
   */
  REACTION_REMOVE_DISLIKE = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export type MarketplacePropertyCategory_ReactionEventReactionJson = "REACTION_UNSPECIFIED" | "REACTION_ADD_LIKE" | "REACTION_REMOVE_LIKE" | "REACTION_ADD_DISLIKE" | "REACTION_REMOVE_DISLIKE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction.
 */
export const MarketplacePropertyCategory_ReactionEventReactionSchema: GenEnum<MarketplacePropertyCategory_ReactionEventReaction, MarketplacePropertyCategory_ReactionEventReactionJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * Media the PDP media slot can occupy. Shared by the impression, toggle,
 * and playback events, and deliberately open-ended: the slot's arms are
 * decided by separate experiments over disjoint inventory, so the count of
 * states it can hold grows independently of any one of them.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState
 */
export enum MarketplacePropertyCategory_ListingMediaState {
  /**
   * @generated from enum value: LISTING_MEDIA_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_PHOTOS = 1;
   */
  PHOTOS = 1,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_VIDEO = 2;
   */
  VIDEO = 2,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_TOUR_3D = 3;
   */
  TOUR_3D = 3,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_FLOOR_PLAN = 4;
   */
  FLOOR_PLAN = 4,
}

/**
 * Media the PDP media slot can occupy. Shared by the impression, toggle,
 * and playback events, and deliberately open-ended: the slot's arms are
 * decided by separate experiments over disjoint inventory, so the count of
 * states it can hold grows independently of any one of them.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState
 */
export type MarketplacePropertyCategory_ListingMediaStateJson = "LISTING_MEDIA_STATE_UNSPECIFIED" | "LISTING_MEDIA_STATE_PHOTOS" | "LISTING_MEDIA_STATE_VIDEO" | "LISTING_MEDIA_STATE_TOUR_3D" | "LISTING_MEDIA_STATE_FLOOR_PLAN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState.
 */
export const MarketplacePropertyCategory_ListingMediaStateSchema: GenEnum<MarketplacePropertyCategory_ListingMediaState, MarketplacePropertyCategory_ListingMediaStateJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export enum MarketplacePropertyCategory_VerificationStep {
  /**
   * @generated from enum value: VERIFICATION_STEP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERIFICATION_STEP_LOGIN = 1;
   */
  LOGIN = 1,

  /**
   * @generated from enum value: VERIFICATION_STEP_PHONE = 2;
   */
  PHONE = 2,

  /**
   * @generated from enum value: VERIFICATION_STEP_IDENTITY = 3;
   */
  IDENTITY = 3,
}

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export type MarketplacePropertyCategory_VerificationStepJson = "VERIFICATION_STEP_UNSPECIFIED" | "VERIFICATION_STEP_LOGIN" | "VERIFICATION_STEP_PHONE" | "VERIFICATION_STEP_IDENTITY";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep.
 */
export const MarketplacePropertyCategory_VerificationStepSchema: GenEnum<MarketplacePropertyCategory_VerificationStep, MarketplacePropertyCategory_VerificationStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * Shared by TourScheduledEvent and TourCompletedEvent. Mirrors
 * od_protos.web.data.viewing_appointment.BookingSource values so
 * emitters can map one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource
 */
export enum MarketplacePropertyCategory_BookingSource {
  /**
   * @generated from enum value: BOOKING_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_SOURCE_INTERNAL_API = 1;
   */
  INTERNAL_API = 1,

  /**
   * @generated from enum value: BOOKING_SOURCE_MOBILE_V1 = 2;
   */
  MOBILE_V1 = 2,

  /**
   * @generated from enum value: BOOKING_SOURCE_ADMIN = 3;
   */
  ADMIN = 3,

  /**
   * @generated from enum value: BOOKING_SOURCE_SHOWINGTIME = 4;
   */
  SHOWINGTIME = 4,
}

/**
 * Shared by TourScheduledEvent and TourCompletedEvent. Mirrors
 * od_protos.web.data.viewing_appointment.BookingSource values so
 * emitters can map one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource
 */
export type MarketplacePropertyCategory_BookingSourceJson = "BOOKING_SOURCE_UNSPECIFIED" | "BOOKING_SOURCE_INTERNAL_API" | "BOOKING_SOURCE_MOBILE_V1" | "BOOKING_SOURCE_ADMIN" | "BOOKING_SOURCE_SHOWINGTIME";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource.
 */
export const MarketplacePropertyCategory_BookingSourceSchema: GenEnum<MarketplacePropertyCategory_BookingSource, MarketplacePropertyCategory_BookingSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

